<template>
  <b-sidebar
    no-header-close
    no-close-on-route-change
    width="15%"
    visible
    no-slide
    z-index="999"
    id="sidebar-1"
    shadow
  >
    <b-row class="logo-sidebar" align-h="center">
      <img style="width:30%; height: 30%" src="@/assets/images/university1.png" href="/" alt />
    </b-row>
    <b-row align-h="center" class="button-group">
      <b-button
        v-for="(item, key) in menu"
        :key="key"
        @click="goRouter(item.link, key)"
        :pressed="item.active"
        class="mt-3 sidebar-button"
      >
        <img
          v-if="item.img && item.img2"
          class="icon-button"
          :src="item.active ? require(`@/assets/images/${item.img}`) : require(`@/assets/images/${item.img2}`)"
          alt
        />
        {{item.titulo}}
      </b-button>
      <div v-if="isAdmin && isSimulacro">
          <li @click="goRouter('/admin/reportes', 6)" class="sub-menu">Resultados</li>
          <li @click="goRouter('/admin/data', 6)" class="sub-menu">Data de contacto</li>
          <li @click="goRouter('/admin/Information', 6)" class="sub-menu">Carga de información</li>
      </div>
    </b-row>
  </b-sidebar>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "Sidebar",
  data: () => ({
    menu: [],
    myToggle: false,
    isSimulacro:false,
    menuEstudiante: [
      {
        titulo: "Resultado",
        img: "result-icon.png",
        img2: "result-icon2.png",
        link: "result",
        active: true
      },
      {
        titulo: "Ayuda",
        img: "help2.png",
        img2: "help.png",
        link: "help",
        active: false
      }
    ],
    menuEstudiante2: [
      {
        titulo: "Simulacro",
        img: "simulacro.png",
        img2: "simulacro2.png",
        link: "/",
        active: true
      }
    ],
    menuAsesor: [
      {
        titulo: "Dashboard",
        img: "dashboard.png",
        img2: "dashboard2.png",
        link: "/asesor/dashboard",
        active: true
      },
      {
        titulo: "Key de Acceso",
        img: "keys.png",
        img2: "keys2.png",
        link: "/asesor/keys",
        active: false
      },
      {
        titulo: "Reportes",
        img: "reportes.png",
        img2: "reportes2.png",
        link: "/asesor/reportes",
        active: false
      },
      {
        titulo: "Data",
        img: "notes.png",
        img2: "notes2.png",
        link: "/asesor/data",
        active: false
      }
    ],
    menuAdmin: [
      {
        titulo: "Dashboard",
        img: "dashboard.png",
        img2: "dashboard2.png",
        link: "/admin/dashboard",
        active: true
      },
      {
        titulo: "Gestion de cuenta",
        img: "keys.png",
        img2: "keys2.png",
        link: "/admin/account",
        active: false
      },
      /*{
                            titulo: "Reportes",
                            img: "reportes.png",
                            img2: "reportes2.png",
                            link: "/asesor/reportes",
                            active: false
                          },*/
      {
        titulo: "Key de Acceso",
        img: "build.png",
        img2: "build2.png",
        link: "/admin/keys",
        active: false
      },
      {
        titulo: "Simulacro",
        img: "reportes.png",
        img2: "reportes2.png",
        link: "/admin/simulacros",
        active: false
      }
      /*{
                            titulo: "Data",
                            img: "notes.png",
                            img2: "notes2.png",
                            link: "/asesor/data",
                            active: false
                          }*/
    ],
    menuColegio: [
      {
        titulo: "Bienvenido",
        img: "",
        img2: "",
        link: "/colegio/bienvenido",
        active: true
      },
      {
        titulo: "Resultados",
        img: "resultado2.svg",
        img2: "resultado.svg",
        link: "/colegio/resultados",
        active: false
      },
      {
        titulo: "Soporte",
        img: "soporte2.svg",
        img2: "soporte.svg",
        link: "/colegio/soporte",
        active: false
      }
    ],
    listUrlColegioResultados: [
      "colegio/resultados-estudiantes",
      "colegio/list-simulacros",
      "colegio/resultados-grupo"
    ]
  }),
  created() {
    let user = JSON.parse(localStorage.getItem("userdata"));
    let menu = localStorage.getItem("menu");
    if (user.tipo == 1) {
      this.menu = this.menuAdmin;
    } else if (user.tipo == 3) {
      this.menu = this.menuColegio;
    } else if (user.tipo == 2) {
      this.menu = this.menuAsesor;
    } else if (menu == 1) {
      this.menu = this.menuEstudiante2;
    } else if (menu == 2) {
      this.menu = this.menuEstudiante;
    }
  },
  mounted() {
    let path = this.$route.path;
    //            this.activeButton(path)
    this.activeButtonRefres(path);
    
  },
  methods: {
    goRouter(url, index) {
       
      this.$router.push("path").catch(error => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
      if (url == "/") {
        window.location.reload();
      }
      if (url == "/asesor/reportes") {
        localStorage.removeItem("search");
      }

      this.$router.replace(url);
      this.menu.forEach(element => {
        element.active = false;
      });

      if(index!=6){
      this.menu[index].active = true;
      }
       if(index==3 || index==6){
          
           this.isSimulacro=true
           this.menu[3].active = true;
        }else{
            this.isSimulacro=false
        }
    },
    activeButton(path) {
      this.menu.forEach(element => {
        element.active = false;
        if (path === element.link) {
          element.active = true;
        }
      });
    },
    activeButtonRefres(path) {
      if (this.listUrlColegioResultados.indexOf(path) !== -1) {
        this.menu[1].active = true;
      } else {
        this.activeButton(path);
      }
    }
  },
  computed: {
    ...mapState(["activeRouteButton"]),
     isAdmin() {
      return this.$store.getters["isAdmin"];
    },
    currentRouteName() {
      let route =
        this.$route.name == "Instruccion" || this.$route.name == "Simulacro"
          ? true
          : false;
      return route;
    },
    currentRoute() {
      return this.$route.name;
    }
  },
  watch: {
    activeRouteButton(value) {
      console.log("aqui cambie", value);
      if (this.listUrlColegioResultados.indexOf(value) !== -1) {
        this.menu[1].active = true;
      } else {
        this.activeButton(value);
      }
    }
  }
};
</script>
<style scoped>
</style>